import { toQuery } from '@/utils/infrastructure';
import request from '@/utils/infrastructure/communication/request';

export async function queryList(params) {
  return request('/customListPreFilter/paged', {
    params: toQuery(params),
  });
}

export async function queryEditItemPreFilter({ id, params }) {
  return request(`/customListPreFilter/${id}`, {
    params: toQuery(params),
  });
}

export async function queryAddNewPreFilter(params) {
  return request.post('/customListPreFilter', {
    data: params,
  });
}

export async function queryAddEditPreFilter(params) {
  return request.put('/customListPreFilter', {
    data: params,
  });
}

export async function queryDeleteItem(id) {
  return request.delete(`/customListPreFilter/${id}`, {});
}

export async function queryEditActive(id) {
  return request.post(`/customListPreFilter/activate/${id}`, {});
}
